module.exports = __webpack_public_path__ + "static/keffiyeh-58d6e14ac2abf22b1b3c8a35a59b8f8a.svg";